import AdminUserState from "./AdminUserState"

export enum AdminUserTypes {    
  SET_ADMIN_USER = "@@adminUser/SET_ADMIN_USER"
}

export type AdminUserAction = { type: AdminUserTypes.SET_ADMIN_USER, data: AdminUserState }

export const setAdminUser = (adminUser: AdminUserState): AdminUserAction => {
  return {
      type: AdminUserTypes.SET_ADMIN_USER,
      data: adminUser
  }
}
